//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { MultiSelectControl } from "@arangodb/ui";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import apiClients from "../../api/apiclients";
import { useDashboardContext } from "../DashboardContextProvider";

const useFetchGroups = () => {
  const { selectedOrganization } = useDashboardContext();

  return useQuery(["groups"], async () => {
    const groups = await apiClients.iamClient.ListGroups({
      context_id: selectedOrganization.id,
    });
    return groups;
  });
};
export const GroupsDropdown = () => {
  const { data: groups, isLoading } = useFetchGroups();
  const options = groups?.items?.map((group) => ({
    label: group.name || "",
    value: group.id || "",
  }));
  return (
    <MultiSelectControl
      label="Groups"
      name="groups"
      selectProps={{
        options,
        isLoading,
        placeholder: "Select groups",
        closeMenuOnSelect: false,
      }}
    />
  );
};
